export default "__VITE_ASSET__o5HIC$Kf__"